import { useMemo } from "react";

import { useBrowserEnvironment } from "./useBrowserEnvironment";

export type AccessType = "DesktopApp" | "Browser" | "MobileApp";

export const useAccessType = (): AccessType => {
    const env = useBrowserEnvironment();

    return useMemo(() => {
        if (env === "WebView") {
            return "DesktopApp";
        }

        if (env === "iOS" || env === "Android") {
            return "MobileApp";
        }

        return "Browser";
    }, [env]);
};
